import { InputNumber } from 'antd'
import { inputNumberSchema } from '../schemas'
import { withFormItem } from './form-item'

export const InputNumberRenderer = withFormItem(inputNumberSchema)(props => {
  const { type, width, ...rest } = props
  return <InputNumber {...rest} style={{ width }} />
})
